const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/HomePage")
  },
  {
    path: "/terms",
    name: "Terms",
    component: () => import("@/views/TermsPage")
  },
  {
    path: "/404",
    component: () => import("@/views/NotFound")
  },
  {
    path: "*",
    redirect: "/404"
  }
];

export default routes;
